//#region src/core/i18n/locales.ts
/** Non-English locale packs shipped with Video.js. */
const LOCALES = [
	"ar",
	"az",
	"bs",
	"bg",
	"bn",
	"ca",
	"cs",
	"cy",
	"da",
	"de",
	"el",
	"es",
	"et",
	"eu",
	"fa",
	"fi",
	"fr",
	"gd",
	"gl",
	"he",
	"hi",
	"hr",
	"hu",
	"id",
	"it",
	"ja",
	"ko",
	"lt",
	"lv",
	"mr",
	"nb",
	"nl",
	"nn",
	"ne",
	"oc",
	"pl",
	"pt-BR",
	"pt-PT",
	"ro",
	"ru",
	"sk",
	"sl",
	"sr",
	"sv",
	"te",
	"th",
	"tr",
	"uk",
	"vi",
	"zh-CN",
	"zh-TW"
];
/** @internal */
function localeAliases(tags) {
	const counts = /* @__PURE__ */ new Map();
	for (const tag of tags) {
		if (!tag.includes("-")) continue;
		const [lang] = tag.split("-");
		if (!lang) continue;
		counts.set(lang, (counts.get(lang) ?? 0) + 1);
	}
	return [...counts].filter(([, count]) => count > 1).map(([lang]) => lang);
}
//#endregion
export { LOCALES, localeAliases };

//# sourceMappingURL=locales.js.map